import React, { Component } from 'react';
import Input from '../../../../ui/input/Input';
import ReactTooltip from 'react-tooltip';

class ContactInfo extends Component {

  _handleInputChange(e) {
    this.props.onChange(e);
  }

  errorClass(error) {
    return(error.length === 0 || this.props.user.type==='admin' ? '' : 'has-error');
  }

	render() {
		return(
			<div className="panel panel--half">
          <ReactTooltip />
          <h2 style={{marginBottom: '2em'}}>Oplysninger om udpeget kontaktperson {this.props.user.type==='user' && <img src="/images/assets/info.svg" alt="info" data-html={true} data-tip="Kontaktoplysninger på den kontaktperson, der er udpeget af trossamfundet/menigheden<br /> til at være ansvarlig i forhold til Trossamfundsregistret i henhold til § 7, stk. 2, nr. 4, i lov nr. 1533 af 19. december 2017 om trossamfund uden for folkekirken. <br />Bemærk, at oplysningerne alene er tilgængelige for By-, Land- og Kirkeministeriet og ikke vises på Trossamfundsregistrets hjemmeside." />}</h2>
				<Input
			        type="text"
			        fullWidth={false}
			        placeholder={this.props.user.type==='user' ? "* Navn" : "Navn" }
			        name="contact_name"
			        autoComplete="off"
                    className={`${this.errorClass(this.props.errors.contact_name)}`}
			        value={this.props.organization.contact_name}
			        onChange={(e) => this._handleInputChange(e)}
			      />
		      	<Input
                    type="text"
                    fullWidth={false}
                    placeholder={this.props.user.type==='user' ? "* E-mail" : "E-mail" }
                    name="contact_email"
                    autoComplete="off"
                    className={`${this.errorClass(this.props.errors.contact_email)}`}
                    value={this.props.organization.contact_email}
                    onChange={(e) => this._handleInputChange(e)}
                  />
                <Input
                    type="text"
                    fullWidth={false}
                    placeholder={this.props.user.type==='user' ? "* Telefon" : "Telefon" }
                    name="contact_phone"
                    autoComplete="off"
                    className={`${this.errorClass(this.props.errors.contact_phone)}`}
                    value={this.props.organization.contact_phone}
                    onChange={(e) => this._handleInputChange(e)}
                  />
            </div>
      	);
	}
}

export default ContactInfo;


// WEBPACK FOOTER //
// ./src/modules/admin/organization/sections/ContactInfo.js